import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";

import {
  setNotificationsCount,
  setNotificationsReceived,
  setNotificationsRequested
} from "../../../actions/dashboardFunctions";
import {fetchJobsForNotifications, setJobBoardRelatedJobs} from "../../JobBoard/JobBoardActions";
import NotificationsButtonAlertsMessages from "./NotificationsButtonAlertsMessages";
import {getCurrentFabricatorId} from "../../../utilities";
import {getParsedJobOrder} from "../../JobBoard/jobPurchaseOrderPopup/jobOrderFunctions";
import {useIsMounted} from "../../../utilities/helperHooks";

let relatedJobsPromise = null;

const NotificationsButton = (props) => {

  const {notificationsCount, notificationsReceived, setNotificationsCount, setNotificationsReceived, notificationsRequested,
    setNotificationsRequested, fetchJobsForNotifications, fabricatorId, relatedJobsNotificationsCount,
    setJobBoardRelatedJobs, relatedJobsFabricatorId} = props;

  // const [dropdownVisible, setDropdownVisible] = useState(false);
  const [dropdownMessages, setDropdownMessages] = useState([]);
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!notificationsRequested) {
      setNotificationsRequested(true);
      const getNotifications = async () => {
        const jobsResponse = await fetchJobsForNotifications();
        console.log("jobsResponse.totalNotUpdatedJobs", jobsResponse.totalNotUpdatedJobs);
        setNotificationsCount(jobsResponse.totalNotUpdatedJobs);
        setNotificationsReceived(true);
      }
      getNotifications();
    }
    return () => {
      setDropdownMessages([]);
    }
  }, [notificationsRequested]);

  const setNotificationMessages = (responseRelated) => {
    if (!Array.isArray(responseRelated) || !responseRelated.length || !isMounted()) {
      return
    }
    setDropdownMessages(responseRelated.map(job => {
      if (!job.jobOrder) {
        return null
      }
      const jobOrder = getParsedJobOrder(job); // jobOrderInterface
      if ((jobOrder.childFabricatorId === fabricatorId) && jobOrder.orderId && !jobOrder.invoiceId) {
        return {
          id: job.id,
          date: job.orderCreatedAt,
          message: `Job ID ${job.id} has purchased order created and requires invoice to be uploaded`
        }
      }
      return null
    }).filter(job => job));
  }

  const requestRelated = async () => {
    setJobBoardRelatedJobs([], null);
    if (relatedJobsPromise) {
      relatedJobsPromise.abort();
      relatedJobsPromise = null;
    }
    relatedJobsPromise = getApiConfig(`JobBoard/${fabricatorId}/jobs/related`);
    relatedJobsPromise.get()
      .then(responseRelated => {
        setNotificationMessages(responseRelated);
        setJobBoardRelatedJobs(Array.isArray(responseRelated) ? responseRelated : [], fabricatorId);
      })
      .catch(() => {
        setNotificationMessages([]);
        setJobBoardRelatedJobs([], fabricatorId);
      })
  }

  useEffect(() => {
    if (fabricatorId !== relatedJobsFabricatorId) {
      requestRelated();
    }
  }, [fabricatorId, relatedJobsFabricatorId]);

  useEffect(() => {
    if (relatedJobsNotificationsCount) { // do not request first time, when it is 0, only after it is changed
      requestRelated();
    }
  }, [relatedJobsNotificationsCount]);

  const handleButtonClick = () => {
    hashHistory.push('jobboard');
  };

  return (
    <div className="header-alerts relative">
      <button className={"central-hub-message-icon" + (false ? " materials-button--active" : "")}
              onClick={handleButtonClick}>
        {notificationsReceived ? (
          <div className={"central-hub-badge" + (dropdownMessages.length ? " bg-red" : " bg-green")}>
            {dropdownMessages.length ? dropdownMessages.length : notificationsCount}
          </div>
        ) : null}
        <div className="central-hub-icon-desc">Alerts</div>
      </button>
      {dropdownMessages.length
        ? <NotificationsButtonAlertsMessages dropdownMessages={dropdownMessages}/>
        : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {notificationsCount, notificationsReceived, notificationsRequested,
    relatedJobsNotificationsCount} = store.dashboardState;
  const {relatedJobsFabricatorId} = store.jobBoard;
  return {
    notificationsCount,
    notificationsReceived,
    notificationsRequested,
    relatedJobsNotificationsCount,
    fabricatorId: getCurrentFabricatorId(store),
    relatedJobsFabricatorId,
  };
};

const mapDispatchToProps = {
  fetchJobsForNotifications,
  setNotificationsCount,
  setNotificationsReceived,
  setNotificationsRequested,
  setJobBoardRelatedJobs,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsButton);
